import moment from 'jalali-moment'
import React, { useState } from 'react'
import { MoneyPoolTransactionTypes } from 'utilities/helper/moneyPools'
import input_vector_icon from 'assets/images/rectangle/input_vector.svg'
import output_vector_icon from 'assets/images/rectangle/output_vector.svg'
import west_vector_icon from 'assets/images/rectangle/west_vector.svg'
import CustomBottomSheet from '../../../../../components/bottomSheet'
import TransactionDetails from './transactionDetails'
import { ConvertJalaliDate } from '../../../../../utilities/helper/digitToMonth'
import {
    getTransactionStatusText,
    isCashin,
    TransactionStatusText,
    TransactionStatusTextDesign,
} from '../../../../../utilities/helper/Funds'
import classNames from 'classnames'

interface IItemProps {
    item: IMoneyPoolTransactionResult
    isManager: boolean
}

export default function Item({ item, isManager }: IItemProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const statusText = TransactionStatusText[getTransactionStatusText(item)]
    // @ts-ignore
    return (
        <div>
            <div className=" border rounded-md py-2 px-2  text-sm my-3 items-center">
                <div className="items-center">
                    <div className="flex mt-2 justify-between">
                        <p className="text-black">{item.poolship_name}</p>
                        {isCashin(item) ? (
                            <p className="text-success-1">
                                {item.amount && item.amount.toLocaleString()}{' '}
                                تومان
                                <div className="inline p-1 rounded-full mr-1.5">
                                    <img
                                        className="inline w-4 h-4 rounded-full p-0.3 bg-green-2"
                                        src={input_vector_icon}
                                        alt="aaa"
                                    />
                                </div>
                            </p>
                        ) : (
                            <p className="text-red-3">
                                {item.amount && item.amount.toLocaleString()}{' '}
                                تومان
                                <div className="inline p-1 rounded-full mr-1.5">
                                    <img
                                        className="inline w-4 h-4 rounded-full p-0.3 bg-red-2 "
                                        src={output_vector_icon}
                                        alt="aaa"
                                    />
                                </div>
                            </p>
                        )}
                    </div>
                    <div className="flex mt-2 justify-content-between">
                        <p className="text-gray-1">
                            {MoneyPoolTransactionTypes[item.type]}
                        </p>
                        <p
                            hidden={!statusText}
                            className={classNames(
                                'pl-2 pr-2 rounded-md ',
                                TransactionStatusTextDesign[
                                    getTransactionStatusText(item)
                                ]
                            )}
                        >
                            {statusText}
                        </p>
                    </div>
                    <div className="flex mt-2 justify-content-between">
                        <p className="text-gray-1 border-blue-1">
                            {item?.jalali_time &&
                                ConvertJalaliDate(item.jalali_time)}{' '}
                            |{' '}
                            <p className="inline">
                                {item.jalali_time &&
                                    moment
                                        .from(
                                            item.jalali_time,
                                            'YYYY-MM-DD HH:mm:ss'
                                        )
                                        .format('HH:mm:ss')}
                            </p>
                        </p>
                        <button onClick={() => setIsOpen(true)}>
                            <p className="text-blue-1">
                                جزئیات تراکنش
                                <img
                                    className="inline pr-2 pl-1 x"
                                    src={west_vector_icon}
                                    alt="aaa"
                                />
                            </p>
                        </button>
                        <CustomBottomSheet
                            onDismiss={() => setIsOpen(false)}
                            isOpen={isOpen}
                        >
                            <TransactionDetails
                                item={item}
                                isManager={isManager}
                                setIsOpen={() => setIsOpen(false)}
                            />
                        </CustomBottomSheet>
                    </div>
                </div>
            </div>
        </div>
    )
}
